export default "__VITE_ASSET__7$Pbk0C6__"